module.exports = __webpack_public_path__ + "img/statss.58bdb84c.png";